import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";

/**
 * fingerprint pro的获取字体宽高代码
 */
import { r, i, E, v } from '../helper/utils/getHash';
var Ee = {
  default: [],
  apple: [{
    font: '-apple-system-body'
  }],
  serif: [{
    fontFamily: 'serif'
  }],
  sans: [{
    fontFamily: 'sans-serif'
  }],
  mono: [{
    fontFamily: 'monospace'
  }],
  min: [{
    fontSize: '1px'
  }],
  system: [{
    fontFamily: 'system-ui'
  }]
};

function I(e, t, n) {
  var o, a;
  return void 0 === n && (n = 50), r(this, void 0, void 0, function () {
    var r, s;
    return i(this, function (i) {
      switch (i.label) {
        case 0:
          ;
          r = document, i.label = 1;

        case 1:
          return r.body ? [3, 3] : [4, v(n)];

        case 2:
          return i.sent(), [3, 1];

        case 3:
          ;
          s = r.createElement('iframe'), i.label = 4;

        case 4:
          return i.trys.push([4,, 10, 11]), [4, new _Promise(function (e, n) {
            var i = !1,
                o = function o() {
              ;
              i = !0, e();
            };

            s.onload = o, s.onerror = function (e) {
              ;
              i = !0, n(e);
            };
            var a = s.style;
            a.setProperty('display', 'block', 'important'), a.position = 'absolute', a.top = '0', a.left = '0', a.visibility = 'hidden', t && 'srcdoc' in s ? s.srcdoc = t : s.src = 'about:blank', r.body.appendChild(s);

            var u = function u() {
              var e, t;
              i || ('complete' === (null === (t = null === (e = s.contentWindow) || void 0 === e ? void 0 : e.document) || void 0 === t ? void 0 : t.readyState) ? o() : setTimeout(u, 10));
            };

            u();
          }) // new Promise(function (e, n) {
          //   ;(u.onload = e), (u.onerror = n)
          //   var i = u.style
          //   console.log(i)
          //   i.setProperty('display', 'block', 'important'),
          //     (i.position = 'absolute'),
          //     (i.top = '0'),
          //     (i.left = '0'),
          //     (i.visibility = 'hidden'),
          //     t && 'srcdoc' in u
          //       ? (u.srcdoc = t)
          //       : (u.src = 'about:blank'),
          //     r.body.appendChild(u)
          // }),
          ];

        case 5:
          i.sent(), i.label = 6;

        case 6:
          return (null === (o = s.contentWindow) || void 0 === o ? void 0 : o.document.body) ? [3, 8] : [4, v(n)];

        case 7:
          return i.sent(), [3, 6];

        case 8:
          return [4, e(s, s.contentWindow)];

        case 9:
          return [2, i.sent()];

        case 10:
          return null === (a = s.parentNode) || void 0 === a || a.removeChild(s), [7];

        case 11:
          return [2];
      }
    });
  });
}

function o_f() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
    e += arguments[t].length;
  }

  var r = Array(e),
      i = 0;

  for (t = 0; t < n; t++) {
    for (var o = arguments[t], a = 0, u = o.length; a < u; a++, i++) {
      r[i] = o[a];
    }
  }

  return r;
}

function b_f(e) {
  return e.reduce(function (e, t) {
    return e + (t ? 1 : 0);
  }, 0);
}

function k() {
  var e = window,
      t = navigator;
  return b_f(['webkitPersistentStorage' in t, 'webkitTemporaryStorage' in t, 0 === t.vendor.indexOf('Google'), 'webkitResolveLocalFileSystemURL' in e, 'BatteryManager' in e, 'webkitMediaStream' in e, 'webkitSpeechGrammar' in e]) >= 5;
}

export var getFontsDisplay = function getFontsDisplay() {
  try {
    return function (e, t) {
      void 0 === t && (t = 4e3);
      return I(function (n, r) {
        var i = r.document,
            a = i.body,
            u = a.style;
        u.width = t + 'px', u.webkitTextSizeAdjust = u.textSizeAdjust = 'none', k() ? a.style.zoom = '' + 1 / r.devicePixelRatio : E() && (a.style.zoom = 'reset');
        var s = i.createElement('div');
        return s.textContent = o_f(Array(t / 20 << 0)).map(function () {
          return 'word';
        }).join(' '), a.appendChild(s), e(i, a);
      }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
    }(function (e, t) {
      for (var n = {}, r = {}, i = 0, o = _Object$keys(Ee); i < o.length; i++) {
        var a = o[i],
            u = Ee[a],
            s = u[0],
            c = void 0 === s ? {} : s,
            l = u[1],
            d = void 0 === l ? 'mmMwWLliI0fiflO&1' : l,
            f = e.createElement('span');
        f.textContent = d, f.style.whiteSpace = 'nowrap';

        for (var v = 0, h = _Object$keys(c); v < h.length; v++) {
          var p = h[v],
              m = c[p];
          void 0 !== m && (f.style[p] = m);
        }

        ;
        n[a] = f, t.appendChild(e.createElement('br')), t.appendChild(f);
      }

      for (var g = 0, bb = _Object$keys(Ee); g < bb.length; g++) {
        r[a = bb[g]] = n[a].getBoundingClientRect().width || -0.0;
      }

      return r;
    });
  } catch (e) {
    var arr = {};

    for (var g = 0, bb = _Object$keys(Ee); g < bb.length; g++) {
      arr[bb[g]] = -0.0;
    }

    return arr;
  }
};